import { Container } from "@mui/material";
import { InputDate, InputPassword, InputSearching } from "@/components/common";
import { AppConstant } from "@/const";

const DemoInput = () => {
  return (
    <Container sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <InputPassword
        onChange={event => {
          console.warn("Password", event.target.value);
        }}
      />

      <InputSearching
        onSearch={keyword => {
          console.warn("Searching", keyword);
        }}
      />

      <InputDate format={AppConstant.FM_SHORT_DATE} />
    </Container>
  );
};

export default DemoInput;
